<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import {computed} from "vue";

const props = defineProps({
  template: {
    required: true,
    type: Object,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const editUri = computed(() => props.adminView ? `/admin/email-templates/${props.template.id}` : `/mail/${props.template.id}`);
</script>

<template>
  <TableRow>
    <TableCell
      col-span="4"
      class="tw-flex tw-space-x-4 tw-items-center tw-cursor-pointer"
    >
      {{ template.name }}
    </TableCell>

    <TableCell
      col-span="6"
      class="tw-flex tw-space-x-4 tw-items-center tw-cursor-pointer"
    >
      {{ template.description }}
    </TableCell>

    <TableCell
      class="tw-flex tw-gap-4 tw-justify-center"
      col-span="2"
    >
      <DefaultButton
        variant="primary-inverted"
        class="!tw-py-2 !tw-px-4 !tw-rounded-lg tw-h-10"
        as="a"
        :href="editUri"
      >
        <svg-vue
          icon="icons/pen"
          class="tw-w-6 tw-h-6"
        />
        <span class="tw-font-semibold tw-antialiased">Edit</span>
      </DefaultButton>
    </TableCell>
  </TableRow>
</template>

